import { BasicRequest } from "./basicRequest";

export class CustomerAbstractsRequest extends BasicRequest{
    public clientIdList:number[]=[];
}